$('.shop-location-pick').on('click', (e) => {
  const $option = $(e.currentTarget);
  const $locationCode = $option.data('shoplocation');
  const $input = $(`<input name="shoplocation" type="hidden" value="${$locationCode}">`);
  const $shoplocationPickerForm = $('#shop-location-picker');
  $shoplocationPickerForm.append($input);
  $shoplocationPickerForm.submit();
});
